var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "c-textarea c-textarea--no-transition c-rap-textarea" },
      [
        _c(
          "label",
          {
            staticClass: "c-textarea__label c-rap-textarea__label",
            attrs: { for: _vm.id }
          },
          [
            _vm._v("\n      " + _vm._s(_vm.question.label) + "\n      "),
            _vm.question.mandatory
              ? _c("span", { staticClass: "c-form-textfield__required" }, [
                  _vm._v("\n        *")
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.question.helpText
          ? _c("div", {
              staticClass: "c-rte",
              domProps: { innerHTML: _vm._s(_vm.question.helpText) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "validation-message",
          {
            attrs: {
              valid: _vm.touched && !_vm.isInvalid,
              invalid: _vm.touched && _vm.isInvalid,
              validationMessage: _vm.validationMessage
            }
          },
          [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value,
                  expression: "value"
                }
              ],
              staticClass: "c-textarea__field c-rap-textarea__field",
              class: { "c-form-textarea__control--is-invalid": _vm.isInvalid },
              attrs: {
                rows: "10",
                cols: "50",
                maxlength: "500",
                id: _vm.id,
                name: _vm.name
              },
              domProps: { value: _vm.value },
              on: {
                blur: _vm.onBlur,
                focus: _vm.onFocus,
                keyup: _vm.onKeyUp,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.value = $event.target.value
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.question.text
          ? _c("div", {
              staticClass: "c-rap-rte",
              domProps: { innerHTML: _vm._s(_vm.question.text) }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.isSubmitted
          ? _c("div", { staticClass: "c-textarea-box__actions" }, [
              _c(
                "button",
                {
                  staticClass:
                    "c-button c-button--brand c-action-buttons__button",
                  attrs: { type: "button" },
                  on: { click: _vm.handleClick }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.question.buttonText) + "\n      "
                  )
                ]
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e9d200e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e9d200e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/_contact-us-rap/_vue/TextareaBox.vue
// module id = 715
// module chunks = 0